const ArrowUpIcon = ({
    width = "14",
    height = "8",
    viewBox = "0 0 14 8",
    fill = "#727580",
    xmlns = "http://www.w3.org/2000/svg",
    ...props
}) => (
    <svg
        width={width}
        height={height}
        viewBox={viewBox}
        fill="none"
        xmlns={xmlns}
        {...props}
    >
        <path
            d="M6.98978 2.50266L1.74504 7.71258C1.54537 7.91093 1.30439 8.00662 1.02212 7.99965C0.740059 7.99288 0.499189 7.89032 0.299513 7.69197C0.0998377 7.49382 0 7.25117 0 6.964C0 6.67683 0.0998377 6.43407 0.299513 6.23572L6.26717 0.307679C6.47366 0.10256 6.71453 0 6.98978 0C7.26503 0 7.5059 0.10256 7.71239 0.307679L13.7008 6.25634C13.9003 6.45448 14 6.69375 14 6.97415C14 7.25455 13.9003 7.49382 13.7008 7.69197C13.5011 7.89032 13.2567 7.98949 12.9677 7.98949C12.6786 7.98949 12.4342 7.89032 12.2345 7.69197L6.98978 2.50266Z"
            fill={fill}
        />
    </svg>
);

export { ArrowUpIcon };
